var exports = {
  "Lv": "MacPermissionsModal.module__intro___UVdBSi",
  "p_": "MacPermissionsModal.module__list___UVdBSi",
  "nM": "MacPermissionsModal.module__row___UVdBSi",
  "of": "MacPermissionsModal.module__rowFocused___UVdBSi",
  "Qq": "MacPermissionsModal.module__text___UVdBSi",
  "UU": "MacPermissionsModal.module__name___UVdBSi",
  "h_": "MacPermissionsModal.module__description___UVdBSi",
  "S8": "MacPermissionsModal.module__restart___UVdBSi",
  "jw": "MacPermissionsModal.module__chip___UVdBSi",
  "Wt": "MacPermissionsModal.module__chipGranted___UVdBSi",
  "qk": "MacPermissionsModal.module__chipDenied___UVdBSi",
  "JL": "MacPermissionsModal.module__chipNotDetermined___UVdBSi",
  "mb": "MacPermissionsModal.module__chipUnsupported___UVdBSi",
  "ne": "MacPermissionsModal.module__controls___UVdBSi",
  "XI": "MacPermissionsModal.module__action___UVdBSi",
};

module.exports = exports;
